var map = {
	"./ar.json": 7144,
	"./cs.json": 4170,
	"./de.json": 7644,
	"./en.json": 4696,
	"./he.json": 5563,
	"./ka.json": 8526,
	"./mne.json": 3029,
	"./pt.json": 3150,
	"./ru.json": 6635,
	"./tr.json": 474,
	"./uk.json": 902,
	"./us.json": 1896,
	"./uz.json": 2311,
	"./zh.json": 8711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1272;